// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8d24c691","735":"ee25cea7"}[chunkId] + ".chunk.js";
};